"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modelProperties = {
    name: 'transactionLog',
    modelName: 'transactionLog',
    tableName: 'transactionLog',
    collectionName: 'transactionlogs',
    index: [{ definition: { 'data.company_id': 1 } }],
};
exports.default = modelProperties;
//# sourceMappingURL=../../../../src/models/transactionLog/modelProperties.js.map